<template>
  <div class="aftersaleBreadCrumb">
    <el-breadcrumb-item>售后管理</el-breadcrumb-item>
    <el-breadcrumb-item :class="{ active: item.url===$route.fullPath }" :to="item.url" v-for="item in breadcrumbList" :key="item.id">{{item.name}}</el-breadcrumb-item>
  </div>
</template>
<script>
export default {
  data () {
    return {
      breadcrumbList: [],
      aftersaleList: [
        { url: '/afterSale/manage', name: '售后单' },
        { url: '/afterSale/abnormal/detail', name: '异常明细' },
        { url: '/afterSale/detail', name: '售后明细' },
        { url: '/afterSale/shippingList', name: '三方售后维修发货清单' }
      ]
    }
  },
  mounted () {
    this.setBreadCrumb(this.$route)
  },
  watch: {
    $route (to, from) {
      this.setBreadCrumb(to)
    }
  },
  methods: {
    setBreadCrumb (to) {
      for (let i of this.aftersaleList) {
        if (i.url === to.path) {
          i.url = to.fullPath
        }
      }
      let currentUrl = this.aftersaleList.filter(item => item.url === to.fullPath)
      if (!this.breadcrumbList.some(item => item.url === to.fullPath)) {
        this.breadcrumbList = this.breadcrumbList.concat(currentUrl)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/breadcrumb/aftersaleBreadCrumb.vue